import React, { memo, useState, useCallback} from 'react';
import {Knob, Arc, Pointer} from 'rc-knob';
import ParameterModulators from './ParameterModulators.js';
import { connect } from "react-redux";

const EffectParameterKnob = memo(({
    isExponential,
    name,
    min,
    max,
    round,
    parameter,
    value,
    sequencerEngine}) => {

    const [showModulators, setShowModulators] = useState(false);

    const onChange = (v) => {
        document.activeElement.blur()
        if (isExponential) {
            v = Math.pow(v, 3);
        }
        if (round) {
            v = Math.round(v);
        }
        parameter.set(v);
    };

    const onClickParameterName = useCallback(() => {
        if (sequencerEngine) {
            setShowModulators(true);
        }
    }, [setShowModulators]);

    const roundValue = (v) => {
        return Math.floor(v * 10.0) / 10;
    };

    let parameterModulators = '';
    if (showModulators) {
        parameterModulators = (
            <ParameterModulators
              sequencerEngine={sequencerEngine}
              parameter={parameter}/>
        );
    }

    min = isExponential ? Math.cbrt(min) : min;
    max = isExponential ? Math.cbrt(max) : max;
    let valueToShow = isExponential ? Math.cbrt(value) : value;
    return (
        <div className="parameter-knob-container">
            <Knob 
              size={40}  
              angleOffset={220} 
              angleRange={280}
              value={valueToShow}
              min={min}
              max={max}
              onChange={value => onChange(value)}
              >
              <Arc 
                arcWidth={3}
                color="white"
                background="#6c757a"
                />
              <Pointer 
                width={3} 
                height={11}
                radius={8}
                type="rect"
                color="white"
                />
            </Knob>
            <div onClick={onClickParameterName} className="knob-label">
              {name} : {roundValue(value)}
            </div>
            {parameterModulators}
        </div>
    );
});

const mapStateToProps = (state, props) => {
    if (props.parameter === undefined) {
        return {
            value: 0,
        };
    }

    let rawValue = state.effects.effectParameters[props.parameter.id];
    return {
        value: rawValue,
    }
};
 
export default connect(mapStateToProps, null)(EffectParameterKnob);


